import { getConfigGet } from "../getConfig";

export const buildUserLookupConfig = (emailOrId: string | number) => {
    if (/^[a-zA-Z0-9]{8}$/.test(String(emailOrId))) {
        return getConfigGet({ referral_code: emailOrId });
    }
    if (isNaN(Number(emailOrId))) {
        return getConfigGet({ email: emailOrId });
    }
    if (String(emailOrId).length < 10) {
        return getConfigGet({ id: emailOrId });
    }
    return getConfigGet({ pps_account_number: emailOrId });
};
